import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../analytics";

/** Fires GA4 page_view on SPA route changes (initial load is covered by gtag config). */
export default function AnalyticsPageView() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(`${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);

  return null;
}
